import Create from "./Create";
import List from "./List";
import Update from "./Update";

export const Shelf = {
  List: List,
  Update: Update,
  Create: Create,
  Permissions: {
    create: "create:HighlightCourseShelf",
    read: "read:HighlightCourseShelf",
    edit: "update:HighlightCourseShelf",
    delete: "delete:HighlightCourseShelf",
    list: "list:HighlightCourseShelf",
  },
};
